import { render, staticRenderFns } from "./shows.vue?vue&type=template&id=f960a4a4&scoped=true&lang=html&"
import script from "./shows.vue?vue&type=script&lang=js&"
export * from "./shows.vue?vue&type=script&lang=js&"
import style0 from "./shows.vue?vue&type=style&index=0&id=f960a4a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f960a4a4",
  null
  
)

export default component.exports